var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRegularPriority = function SvgRegularPriority(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    "data-name": "Urgent box",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 1510"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3484.556-1619.756a.544.544 0 0 1-.288-.082.556.556 0 0 1-.2-.221.571.571 0 0 1-.063-.3.575.575 0 0 1 .1-.287l4.69-6.914h-3.745c-.271 0-.491-.323-.491-.721s.221-.72.491-.72h9.817c.271 0 .491.323.491.72s-.22.721-.491.721h-4.542l4.689 6.914a.572.572 0 0 1 .1.287.572.572 0 0 1-.063.3.553.553 0 0 1-.2.222.543.543 0 0 1-.287.083z",
    "data-name": "Union 1",
    style: {
      fill: "#fff"
    },
    transform: "translate(-3481.553 1632)"
  }));
};
export default SvgRegularPriority;